export default __webpack_public_path__ + "static/media/ql_13.24912332.png";